import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";

import OmniDeviceLayout from "./OmniDeviceLayout.component";
import AppButton from "../../base/AppButton.component";
import Theme from "../../../utils/Theme";
import { OmniStyles } from "./OmniStyles";
import ServiceUtils from "./ServiceUtils.component";
import { ServiceData } from "./ServiceData";
import { ServiceStyle } from "./ServiceStyle";
import { useAuth } from "../../../context/Auth.context";
import { useVerification } from "../../../context/Verification.context";
import { useMutation, useQuery } from "@apollo/client";
import { CHECK_SERVICES } from "../../../graphql/query/query";
import {
  SEND_EMAIL,
  SEND_EMAIL_ARTIFACT,
  SEND_TEXT,
  SEND_TEXT_ARTIFACT,
} from "../../../graphql/mutation/mutation";
import { appUrl, capitalizeFirstLetter } from "../../../utils/Utils";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../../context/App.context";

const ServiceListingComponent = () => {
  const auth = useAuth();
  const verification = useVerification();
  const navigate = useNavigate();
  const app = useAppContext();

  const [preference, setPreference] = useState({
    verification: 0,
    artifacts: 0,
    driverLicence: 0,
    prequal: 0,
  });
  const [customer, setCustomer] = useState({});
  const [serviceData, setServiceData] = useState();

  useEffect(() => {
    if (verification?.customer) {
      setCustomer(verification?.customer);
    }
  }, []);

  const { data: checkService, loading: serviceLoading } = useQuery(
    CHECK_SERVICES,
    {
      variables: {
        serviceInput: {
          user_id: parseInt(verification?.customer?.userId),
        },
      },
    }
  );

  useEffect(() => {
    if (checkService) {
      const isVerification = checkService?.checkServices?.isVerification;
      const isArtifacts = checkService?.checkServices?.isArtifacts;
      verification?.setServices((prev) => ({
        ...prev,
        artifactService: isArtifacts || false,
        insuranceService: isVerification || false,
      }));
    }
  }, [checkService]);

  const [sendText, { loading: textLoading, data: textData }] =
    useMutation(SEND_TEXT);

  const [sendEmail, { loading, data: emailData }] = useMutation(SEND_EMAIL);
  const [
    sendEmailArtifact,
    { loading: artifactEmailLoading, data: emailArtifactData },
  ] = useMutation(SEND_EMAIL_ARTIFACT);
  const [
    sendTextArtifact,
    { loading: artifactTextLoading, data: textArtifactData },
  ] = useMutation(SEND_TEXT_ARTIFACT);
  console.log("handleChange", preference);
  const page = 0;
  const setServices = (value) => {
    if (value === "artifacts") {
      verification?.setServices((prev) => ({
        ...prev,
        artifactService: true,
      }));
    }
    if (value === "insurance") {
      verification?.setServices((prev) => ({
        ...prev,
        insuranceService: true,
      }));
    }
  };
  const handleInsurance = () => {
    if (preference.verification === 3) {
      console.log("333333333");
      setServices("insurance");
      window.open(
        `/verification/consent/${auth?.user?.user_id}/${
          auth?.user?.dealership_id
        }/${verification?.customer.userId}/${
          verification?.customer?.isWalkthrough
        }/0/${false}?service=1&express=true`,
        "_blank"
      );
    } else if (preference.verification === 2) {
      sendText({
        variables: {
          verificationRequestInput: {
            user: {
              user_id: customer?.userId,
              first_name: customer.firstName,
              middle_name: " ",
              last_name: customer.lastName,
              email: customer.email,
              phone_number: customer.mobileNumber,
            },
            employee: {
              employee_user_id: auth.user.user_id.toString(),
              employee_firstname: auth.user.first_name,
              employee_lastname: auth.user.last_name,
            },
            url:
              appUrl +
              `/verification/consent/${auth?.user?.user_id}/${
                auth?.user?.dealership_id
              }/${verification?.customer.userId}/${
                verification?.customer?.isWalkthrough
              }/0/${false}?service=1`,
            dealership: {
              dealership_name: auth.user.dealership_name,
            },
            isRepull: false,
          },
        },
      }).then(() => setServices("insurance"));
    } else if (preference.verification === 1) {
      sendEmail({
        variables: {
          verificationRequestInput: {
            user: {
              user_id: customer?.userId,
              first_name: customer.firstName,
              middle_name: " ",
              last_name: customer.lastName,
              email: customer.email,
              phone_number: customer.mobileNumber,
            },
            employee: {
              employee_user_id: auth.user.user_id.toString(),
              employee_firstname: auth.user.first_name,
              employee_lastname: auth.user.last_name,
            },
            url:
              appUrl +
              `/verification/consent/${auth?.user?.user_id}/${
                auth?.user?.dealership_id
              }/${verification?.customer.userId}/${
                verification?.customer?.isWalkthrough
              }/0/${false}?service=1`,
            dealership: {
              dealership_name: auth.user.dealership_name,
            },
            isRepull: false,
          },
        },
      }).then(() => setServices("insurance"));
    }
  };
  console.log("preference", preference);

  const handleArtifact = () => {
    if (preference.artifacts === 3) {
      setServices("artifacts");
      window.open(
        `/verification/consent/${auth?.user?.user_id}/${
          auth?.user?.dealership_id
        }/${verification?.customer.userId}/${
          verification?.customer?.isWalkthrough
        }/0/${false}?service=2&channel=device`,
        "_blank"
      );
    } else if (preference.artifacts === 2) {
      sendTextArtifact({
        variables: {
          verificationRequestInput: {
            user: {
              user_id: customer?.userId,
              first_name: customer.firstName,
              middle_name: " ",
              last_name: customer.lastName,
              email: customer.email,
              phone_number: customer.mobileNumber,
            },
            employee: {
              employee_user_id: auth.user.user_id.toString(),
              employee_firstname: auth.user.first_name,
              employee_lastname: auth.user.last_name,
            },
            url:
              appUrl +
              `/verification/consent/${auth?.user?.user_id}/${
                auth?.user?.dealership_id
              }/${verification?.customer.userId}/${
                verification?.customer?.isWalkthrough
              }/0/${false}?service=2&channel=text`,
            dealership: {
              dealership_name: auth.user.dealership_name,
            },
            isRepull: false,
          },
        },
      }).then(() => setServices("artifacts"));
    } else if (preference.artifacts === 1) {
      sendEmailArtifact({
        variables: {
          verificationRequestInput: {
            user: {
              user_id: customer?.userId,
              first_name: customer.firstName,
              middle_name: " ",
              last_name: customer.lastName,
              email: customer.email,
              phone_number: customer.mobileNumber,
            },
            employee: {
              employee_user_id: auth.user.user_id.toString(),
              employee_firstname: auth.user.first_name,
              employee_lastname: auth.user.last_name,
            },
            url:
              appUrl +
              `/verification/consent/${auth?.user?.user_id}/${
                auth?.user?.dealership_id
              }/${verification?.customer.userId}/${
                verification?.customer?.isWalkthrough
              }/0/${false}?service=2&channel=email`,
            dealership: {
              dealership_name: auth.user.dealership_name,
            },
            isRepull: false,
          },
        },
      }).then(() => setServices("artifacts"));
    }
  };
  const handleboth = () => {
    if (preference.verification === 3 && preference.artifacts === 3) {
      setServices("insurance");
      setServices("artifacts");
      window.open(
        `/verification/consent/${auth?.user?.user_id}/${
          auth?.user?.dealership_id
        }/${verification?.customer.userId}/${
          verification?.customer?.isWalkthrough
        }/0/${false}?service=1&service=2&channel=device`,
        "_blank"
      );
    } else if (preference.verification === 2 && preference.artifacts === 2) {
      sendText({
        variables: {
          verificationRequestInput: {
            user: {
              user_id: parseInt(customer?.userId),
              first_name: customer.firstName,
              middle_name: " ",
              last_name: customer.lastName,
              vin: customer.vin,
              email: customer.email,
              phone_number: customer.mobileNumber,
            },
            employee: {
              employee_user_id: auth.user.user_id.toString(),
              employee_firstname: auth.user.first_name,
              employee_lastname: auth.user.last_name,
            },
            url:
              appUrl +
              `/verification/consent/${auth?.user?.user_id}/${
                auth?.user?.dealership_id
              }/${verification?.customer.userId}/${
                verification?.customer?.isWalkthrough
              }/0/${false}?service=1&service=2&channel=text`,
            dealership: {
              dealership_name: auth.user.dealership_name,
            },
          },
        },
      });
    } else if (preference.verification === 1 && preference.artifacts === 1) {
      sendEmail({
        variables: {
          verificationRequestInput: {
            user: {
              user_id: customer?.userId,
              first_name: customer.firstName,
              middle_name: " ",
              last_name: customer.lastName,
              email: customer.email,
              phone_number: customer.mobileNumber,
            },
            employee: {
              employee_user_id: auth.user.user_id.toString(),
              employee_firstname: auth.user.first_name,
              employee_lastname: auth.user.last_name,
            },
            url:
              appUrl +
              `/verification/consent/${auth?.user?.user_id}/${auth?.user?.dealership_id}/${verification?.customer.userId}/${verification?.customer?.isWalkthrough}/0/false?service=1&service=2&channel=email`,
            dealership: {
              dealership_name: auth.user.dealership_name,
            },
            isRepull: false,
          },
        },
      });
    } else if (
      preference.verification === 2 ||
      preference.artifacts === 1 ||
      preference.verification === 1 ||
      preference.artifacts === 2 ||
      preference?.verification === 3 ||
      preference?.artifacts === 3
    ) {
      handleArtifact();
      handleInsurance();
    }
  };
  console.log("preference", preference);
  const handleClose = () => {
    auth.logout();
    app.removeAll();
    navigate("/express");
  };
  const handleChange = (service) => {
    if (service === "verification") {
      handleInsurance();
    } else if (service === "artifacts") {
      handleArtifact();
    }
  };

  useEffect(() => {
    if (auth?.user?.services?.length > 0) {
      const insurance = auth?.user?.services?.find((x) => x.service_id === 1);
      const artifacts = auth?.user?.services?.find((x) => x.service_id === 2);
      const driverLicense = auth?.user?.services?.find(
        (x) => x.service_id === 3
      );
      const prequal = auth?.user?.services?.find((x) => x.service_id === 4);
      setServiceData({
        insurance,
        artifacts,
        driverLicense,
        prequal,
      });
      console.log("insurance", insurance);
    }
  }, [auth?.user?.services]);

  const dealerLogo =
    auth?.user?.dealership_logo || verification?.dealershipLogo;

  useEffect(() => {
    if (auth?.user?.dealership_logo) {
      verification.setDealershipLogo(auth.user.dealership_logo);
    }
  }, [auth?.user?.dealership_logo, auth?.user?.dealership_id]);

  // Shared style for the value cells so long names / emails / numbers
  // truncate with an ellipsis instead of overflowing or wrapping.
  const truncatedAnswerCellSx = {
    ...OmniStyles.answercell,
    minWidth: 0,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  return (
    <>
      <OmniDeviceLayout>
        <Box sx={{ ...ServiceStyle.mainBox, justifyContent: "flex-start" }}>
          <Box sx={{ ...ServiceStyle.dealerLogo, height: "10%" }}>
            <Box sx={{ display: "flex", flex: 1, justifyContent: "center" }}>
              {dealerLogo && (
                <img
                  src={dealerLogo}
                  width={160}
                  alt="dealer logo"
                  style={{ objectFit: "contain" }}
                />
              )}
            </Box>

            <AppButton
              buttonText={"EXIT"}
              variant={"text"}
              sx={{
                color: Theme.palette.error.main,
                alignSelf: "center",
                marginLeft: "auto",
                marginRight: {
                  xs: -2, // mobile
                  sm: 0, // tablet
                  md: 2.5, // desktop
                },
              }}
              clickHandler={handleClose}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "30%",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "grid",
                // First column sizes to the label; second column is constrained
                // (minmax(0, 1fr)) so overflow/ellipsis on long values actually works.
                // max-content on both columns previously let the value cell grow to
                // fit its content, which silently defeated the truncation styles.
                gridTemplateColumns: "max-content minmax(0, 1fr)",
                columnGap: 2,
                rowGap: 0,
                width: "100%",
                maxWidth: 360,
                mx: "auto",
              }}
            >
              <Box sx={OmniStyles.tableCell}>Employee:</Box>
              <Box sx={truncatedAnswerCellSx}>
                {capitalizeFirstLetter(auth?.user?.first_name)}{" "}
                {capitalizeFirstLetter(auth?.user?.last_name)}
              </Box>

              <Box sx={OmniStyles.tableCell}>Guest:</Box>
              <Box sx={truncatedAnswerCellSx}>
                {capitalizeFirstLetter(verification?.customer?.firstName)}{" "}
                {capitalizeFirstLetter(verification?.customer?.lastName)}
              </Box>

              <Box sx={OmniStyles.tableCell}>Email:</Box>
              <Box sx={truncatedAnswerCellSx}>
                {verification?.customer?.email}
              </Box>

              <Box sx={OmniStyles.tableCell}>Cell:</Box>
              <Box sx={truncatedAnswerCellSx}>
                {verification?.customer?.mobileNumber}
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              ...ServiceStyle.listBox,
              ml: 2, // shift the row group slightly to the right
              height: "40%",
              justifyContent: "flex-start", // keep rows anchored to the top, leaving the gap at the bottom
            }}
          >
            <ServiceUtils
              data={serviceData?.driverLicense}
              ServiceName={"License"}
              isDisable={true}
              isRepull={false}
              preference={preference?.driverLicence}
            />
            <ServiceUtils
              data={serviceData?.prequal}
              ServiceName={"Credit"}
              isDisable={true}
              isRepull={false}
              preference={preference?.prequal}
            />
            <ServiceUtils
              service={"verification"}
              ServiceName={"Insurance"}
              data={serviceData?.insurance}
              isRepull={verification?.services?.insuranceService}
              isDisable={
                auth?.user?.services?.some((s) => s.service_id === 1)
                  ? false
                  : true
              }
              handleChange={handleChange}
              preference={preference?.verification}
              setPreference={setPreference}
              loading={textLoading || loading}
            />
            <ServiceUtils
              service={"artifacts"}
              ServiceName={"Information"}
              data={serviceData?.artifacts}
              isRepull={verification?.services?.artifactService}
              isDisable={
                auth?.user?.services?.some((s) => s.service_id === 2)
                  ? false
                  : true
              }
              handleChange={handleChange}
              preference={preference?.artifacts}
              setPreference={setPreference}
              loading={artifactEmailLoading || artifactTextLoading}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: 1,
              height: "20%",
              // Give this row a floor so it can never be squeezed thinner
              // than what the GO button + helper text actually need, no
              // matter how the surrounding percentage-height math works out
              // on a given device (this is what was collapsing on iPhone XR).
              minHeight: 96,
              flexShrink: 0,
              width: "100%",
              pb: "env(safe-area-inset-bottom, 0px)",
            }}
          >
            <AppButton
              buttonText={"GO"}
              sx={{
                width: "50%",
                minHeight: 44, // keeps the tap target usable even if squeezed
              }}
              clickHandler={() => {
                handleboth();
              }}
              disabled={
                preference?.verification === 0 &&
                preference?.artifacts === 0 &&
                preference?.driverLicence === 0 &&
                preference?.prequal === 0
              }
            />
            <span
              style={{
                fontSize: "12px",
                color: Theme.palette.text.secondary,
              }}
            >
              Use the GO button to launch multiple functions with one click
            </span>
          </Box>
        </Box>
      </OmniDeviceLayout>
    </>
  );
};
export default ServiceListingComponent;